import { useEffect } from 'react'
import { useSiteContent } from '../../content/useSiteContent'

/**
 * Small site-wide things that live outside any page: the browser-tab icon, set from Site content → Logos & icon.
 * Renders nothing.
 */
export default function SiteChrome() {
  const { site } = useSiteContent()
  const rawFavicon = site?.branding?.favicon
  // Wide banner/logo images distort in 1:1 browser tabs; fallback to square favicon if legacy logo is set
  const favicon = (!rawFavicon || rawFavicon === '/RayOpticsLogo.png') ? '/favicon.png' : rawFavicon

  useEffect(() => {
    let link = document.querySelector('link[rel~="icon"]')
    if (!link) {
      link = document.createElement('link')
      link.rel = 'icon'
      document.head.appendChild(link)
    }
    if (favicon && link.getAttribute('href') !== favicon) link.setAttribute('href', favicon)
  }, [favicon])

  return null
}
